module.exports = __webpack_public_path__ + "static/media/2.9_preview.b6ac43f7.png";